export const isEmpty = (obj) => (!obj ? true : false);
